import type { CustomCellRendererProps } from "ag-grid-react";

import { Button } from "@synthesis/shared-ui";
import { IconBin, IconDownload } from "@synthesis/shared-icons";

import type { ReviewDocumentRow, ReviewDocumentTableContext } from "./review-documents-tab.lib";

export const ReviewDocumentActionsCell = ({ data, context }: CustomCellRendererProps<ReviewDocumentRow, unknown, ReviewDocumentTableContext>) => {
  if (!data) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-1">
      <Button
        type="button"
        theme="text"
        size="sm"
        shape="square"
        aria-label="Скачать документ"
        onClick={() => context.onDownload(data)}
        icon={<IconDownload className="size-5" />}
      />
      {context.canDelete ? (
        <Button
          type="button"
          theme="text"
          size="sm"
          shape="square"
          aria-label="Удалить документ"
          onClick={() => context.onDelete(data)}
          icon={<IconBin className="size-5" />}
        />
      ) : null}
    </div>
  );
};
